import * as React from 'react';
import { Block, Section, Viewer } from '../../modules';
import { Result, ResultFactory } from '../../resource/'; 
import { RouteComponentProps } from 'react-router';
import { IAuthProps } from '../../services/Auth';

import { Tabs } from '@independent-software/typeui/controls/Tabs';
import { ToastService } from '@independent-software/typeui/controls/Toast';
import { Flex } from '@independent-software/typeui/controls/Flex';
import { Header } from '@independent-software/typeui/controls/Header';
import { Output } from '../../controls/Output';
import { Number } from '@independent-software/typeui/formatters/Number';
import { Icon } from '@independent-software/typeui/controls/Icon';
import { ValueDescription } from './ValueDescription';
import { ExtraValueDescription } from './ExtraValueDescription';
import { Datum } from '@independent-software/typeui/formatters/Datum';
import { Label } from '@independent-software/typeui/controls/Label';

class ViewResult extends React.Component<IAuthProps & RouteComponentProps<{id:string}>, {}> {
  private handleEdit = () => {
    this.props.history.push(`/results/edit/${parseInt(this.props.match.params.id)}`);
  }

  private handleDelete = () => {
    ToastService.toast("Result deleted.");
    this.props.history.push('/results');
  }    

  render() {
    let p = this.props;
    return (
      <Viewer<Result> 
        auth={p.auth}
        id={parseInt(p.match.params.id)}
        factory={ResultFactory}
        canEdit='can_edit_results'
        canDelete='can_delete_results'
        onEdit={this.handleEdit}
        onDelete={this.handleDelete}
        content={(result: Result) => 
          <React.Fragment>
            <Section dark padded>
              <Header size="h1"><Label>{result.sample.station.name}</Label> <Label>{result.sample.campaign.name}</Label> <Label><Datum.ShortDate value={result.sample.date}/></Label> {result.sample.time && <Label><Datum.Time value={result.sample.time}/></Label>}</Header>
            </Section>
            <Tabs underlined>
              <Tabs.Pane label="Data">
                <Section padded="very">
                  <Block title="Location">
                    <Flex.Columns count={2}>  
                      <Output label="Station" hint="Station name">{result.sample.station.name}</Output>
                      <Output label="Campaign" hint="Campaign name">{result.sample.campaign.name}</Output>
                    </Flex.Columns>
                  </Block>
                  <Block title="Sample">
                    <Flex.Columns count={2}>  
                      <Output label="Sample date" hint="Sample date">{result.sample.date ? <Datum.LongDate value={result.sample.date}/> : '-'}</Output>
                      <Output label="Sample time" hint="Sample time">{result.sample.time ? <Datum.Time value={result.sample.time}/> : '-'}</Output>
                      <Output label="Sample depth" hint="Sample depth">{result.sample.depth ? <Number value={result.sample.time} decimals={3}/> : '-'}</Output>
                    </Flex.Columns>
                  </Block>
                  <Block title="Value">
                    <Flex.Columns count={2}>
                      <Output label="Parameter" hint="Parameter">{result.parameter.name}</Output>
                      <Output label="Value" hint="Measured value" unit={result.parameter.unit}>{result.value ? <Number value={result.value}/> : '-'}</Output>
                      <Output label="Description" hint="Value description">{result.description ? ValueDescription.toName(result.description) : '-'}</Output>
                      <Output label="Detection limit" hint="Is value at detection limit of parameter?">{result.detection_limit ? <><Icon size="small" name="check"/> Yes</> : <><Icon size="small" name="times"/> No</>}</Output>
                    </Flex.Columns>
                  </Block>
                </Section>
              </Tabs.Pane>
              <Tabs.Pane label="Additional data">
                <Section padded="very">
                  <Flex.Columns count={2}>
                    <Output label="Extra value" hint="Additional value (e.g. for duplicate analysis or a standard deviation)" unit={result.parameter.unit}>{result.extra_value ? <Number value={result.extra_value}/> : '-'}</Output>
                    <Output label="Extra description" hint="Description of additional value">{result.extra_description ? ExtraValueDescription.toName(result.extra_description) : '-'}</Output>
                    <Output label="Minimum value" hint="Additional value (e.g. lower value for replicate analysis)" unit={result.parameter.unit}>{result.minvalue ? <Number value={result.minvalue}/> : '-'}</Output>
                    <Output label="Maximum value" hint="Additional value (e.g. higher value for replicate analysis)" unit={result.parameter.unit}>{result.maxvalue ? <Number value={result.maxvalue}/> : '-'}</Output>
                    <Output label="Replicates" hint="Number of replicates (one if single value)">{result.replicates ? <Number value={result.replicates} decimals={0}/> : '-'}</Output>
                  </Flex.Columns>
                </Section>
              </Tabs.Pane>
            </Tabs>
          </React.Fragment>}>
      </Viewer>
    );
  }
}

export { ViewResult };
